import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { makeRequest, METHODS } from './baseRequest.js';
import { ENVIRONMENTS } from '../constants/environments.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';
import settings from '../settings.js';
import { buildUrl } from '../utils/buildUrl.js';
import { memoizeAsync } from '../utils/memoize.js';

function joinWithDevQuery(url) {
    if (settings.showDevPanel) {
        const queryParams = {};
        if (settings.country) {
            queryParams.country = settings.country;
        }
        if (settings.environment === ENVIRONMENTS.TEST) {
            queryParams.environment = settings.environment;
        }
        if (Object.keys(queryParams).length > 0) {
            return `${url}?${Object.entries(queryParams)
                .map(([k, v]) => `${k}=${v}`)
                .join('&')}`;
        }
    }
    return url;
}
function fetchStorefrontByPlatform(platform, customStorefrontName, language) {
    return __awaiter(this, void 0, void 0, function* () {
        const storefrontName = customStorefrontName || settings.storefrontName;
        const url = buildUrl(settings.storefrontUrl, {
            platform,
            language: language || settings.language,
            backendUrl: settings.backendUrl,
            storefrontName,
        });
        return makeRequest(METHODS.GET, joinWithDevQuery(url))
            .then((response) => response)
            .catch(() => {
            events.emit(EVENTS.SHOP_UNAVAILABLE, { storefrontName });
            return {};
        });
    });
}
const getStorefrontByPlatform = memoizeAsync(fetchStorefrontByPlatform.name, fetchStorefrontByPlatform);
function getProductVariablePrice(productCode, quantity, platform, customStorefrontName, language) {
    return __awaiter(this, void 0, void 0, function* () {
        const storefrontName = customStorefrontName || settings.storefrontName;
        const url = buildUrl(settings.webGetProductVariablePriceUrl, {
            platform,
            language: language || settings.language,
            backendUrl: settings.backendUrl,
            storefrontName,
            productCode: productCode,
            quantity: quantity,
        });
        return makeRequest(METHODS.GET, joinWithDevQuery(url))
            .then((response) => response)
            .catch(() => {
            events.emit(EVENTS.SHOP_UNAVAILABLE, { storefrontName });
            return {};
        });
    });
}

export { getProductVariablePrice, getStorefrontByPlatform };
//# sourceMappingURL=storefront.js.map
